
/**
 * Task model — supports both regular Tasks table and CP Tasks table
 * Regular Tasks: fields 3(rid), 6(planQty), 11(description), 12(billingCodeRecordId), 13(billingCodeString), 14(relatedJob)
 * CP Tasks: fields 3(rid), 6(planQty), 49(relatedCPBillingCode), 54(description), 73(billingCodeString)
 */
export class Task {
  rid?: number;
  planQty?: number;
  relatedCPBillingCode?: number;
  CPBillingCodeDescription?: string;
  CPBillingCode?: string;

  get codeWithDescription():string{
    return this.CPBillingCode + ' - ' + this.CPBillingCodeDescription;
  }

  constructor(data?: any) {
    if (!data) {
      return;
    }

    this.rid = data[3]?.value;
    this.planQty = data[6]?.value;

    // Regular Tasks table: field 13 = Billing Code string (e.g. "US09")
    if (data[13]?.value) {
      this.CPBillingCode = data[13].value;
    }
    // CP Tasks table: field 73 = CP Billing Code string
    if (data[73]?.value) {
      this.CPBillingCode = data[73].value;
    }

    // Regular Tasks table: field 12 = Related Billing Code record ID
    if (data[12]?.value) {
      this.relatedCPBillingCode = data[12].value;
    }
    // CP Tasks table: field 49 = Related CP Billing Code record ID
    if (data[49]?.value) {
      this.relatedCPBillingCode = data[49].value;
    }

    // Regular Tasks table: field 11 = Client/Project description
    if (data[11]?.value) {
      this.CPBillingCodeDescription = data[11].value;
    }
    // CP Tasks table: field 54 = CP Billing Code Description
    if (data[54]?.value) {
      this.CPBillingCodeDescription = data[54].value;
    }
  }
}
